import { useMemo } from 'react'
import { useObjectAlarms } from '../../../hooks/useObjectAlarms'
import { useMediaQuery } from '../../../hooks';
import { useStyletron } from 'baseui';
import { getAlarmClassStyle } from '../../../features/Alarm/alarmClassStyles';
import { FlexGridCard } from './FlexGridCard';

const CardWithAlarm = (props: {objectId?, resourceGroupId?, key?, children, small?: boolean}) => {
    const [css, theme] = useStyletron();
    const { items: data, error, isLoading } = useObjectAlarms(props.objectId,props.resourceGroupId)
    const isSmallScreen = useMediaQuery('screen and (max-width: 600px)');
    
    const first = useMemo(() => {
        return data?.slice()[0]
      }, [data]);

      const aclass = first ? getAlarmClassStyle(first?.alarmClass.name, first?.offTime !== undefined && first?.offTime !== null,theme) : undefined;
    
      const alarmStyle = {
        Root: {
            style: ({ $theme }) => ({
                border: `1px solid ${aclass?.color}`,
                //borderWidth: '2pt'
                
            })
        }
    };
    const cardStyle = first ? alarmStyle : undefined;
    const smallStyle = first ? `1px solid ${aclass?.color}` : undefined;
    const overrideStyle = isSmallScreen ? smallStyle : cardStyle;
    return (<FlexGridCard small={props.small} cardStyleOverride={overrideStyle}>{props.children}</FlexGridCard>)
}

export default CardWithAlarm;

